import { createAction } from "redux-actions";

export const getConfigCiTestCasesStatuses = createAction("GET_CONFIG_CI_TEST_CASES_STATUSES");
export const setConfigCiTestCasesStatuses = createAction("SET_CONFIG_CI_TEST_CASES_STATUSES");
